import { render, staticRenderFns } from "./CancelLicense.vue?vue&type=template&id=57b82082"
import script from "./CancelLicense.vue?vue&type=script&lang=js"
export * from "./CancelLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports